import { createContext, useContext } from "react";
import type { AccessToken, Model, Version } from "../../types";
import type { RunWithContext } from "../api-playground/run-with";

type RunDialogContext = {
  model: Model;
  version: Version;
  token: AccessToken;
  language: RunWithContext;
  setLanguage: (language: RunWithContext) => void;
};

export const RunDialogContext = createContext<RunDialogContext>(
  {} as RunDialogContext
);

export const useRunDialogContext = () => {
  return useContext(RunDialogContext);
};
